/**
 * One location for every PawBazaar site (shop, care, community): kept in a
 * cookie on the parent domain (.pawbazaar.store), so choosing it on one site
 * shows the same place on the others. {pincode, lat, lng, label, detail,
 * source, ts}. Not secret: it's what the visitor picked.
 */
const NAME = "pb_loc";
const YEAR = 365 * 24 * 3600;
const EVENT = "pb:location";

function domainPart() {
  const h = typeof window !== "undefined" ? window.location.hostname : "";
  return h === "pawbazaar.store" || h.endsWith(".pawbazaar.store") ? ";domain=.pawbazaar.store" : "";
}

export function readShared() {
  try {
    const row = document.cookie.split("; ").find((c) => c.startsWith(`${NAME}=`));
    if (!row) return null;
    const v = JSON.parse(decodeURIComponent(row.slice(NAME.length + 1)));
    return v && (v.pincode || (v.lat != null && v.lng != null)) ? v : null;
  } catch { return null; }
}

export function writeShared(loc) {
  try {
    const keep = loc ? Object.fromEntries(Object.entries({ pincode: loc.pincode || null, lat: loc.lat ?? null, lng: loc.lng ?? null,
      label: loc.label || null, detail: loc.detail || null, source: loc.source || null }).filter(([, x]) => x != null)) : null;
    const secure = window.location.protocol === "https:" ? ";secure" : "";
    document.cookie = keep
      ? `${NAME}=${encodeURIComponent(JSON.stringify({ ...keep, ts: Date.now() }))};path=/;max-age=${YEAR};samesite=lax${domainPart()}${secure}`
      : `${NAME}=;path=/;max-age=0;samesite=lax${domainPart()}${secure}`;
    window.dispatchEvent(new Event(EVENT));
  } catch { /* cookies blocked: this site still keeps its own copy */ }
}

/** Calls back with the shared location when another tab or site changed it. */
export function onSharedChange(cb) {
  let last = JSON.stringify(readShared());
  const check = () => { const now = JSON.stringify(readShared()); if (now !== last) { last = now; cb(readShared()); } };
  window.addEventListener(EVENT, check);
  window.addEventListener("focus", check);
  document.addEventListener("visibilitychange", check);
  const t = setInterval(check, 5000);
  return () => { window.removeEventListener(EVENT, check); window.removeEventListener("focus", check); document.removeEventListener("visibilitychange", check); clearInterval(t); };
}
